import { Fragment } from 'react';
import AppStyleDecider from '../../../../../../../../../../baseComponents/AppsStyleDecider';
import { OrderStepButtonsBaseComponentProps } from '../../../../../../../../../../specificComponents/inputTableLayouts/order/OrderLayout/OrderButtonsBaseComponent/types';
import QuoteOrderStatusBar, { QuoteOrderStatusBarNew, QuoteOrderStatusBarProps } from '../../../../../../../../../../specificComponents/inputTableLayouts/order/OrderQuoteLayout/QuoteOrderStatusBar';
import QuoteOrderFinishedStepButtons, { QuoteOrderFinishedStepButtonsNew } from '../QuoteOrderFinishedStepButtons';

type QuoteOrderFinishedStepHeaderProps = & QuoteOrderStatusBarProps & OrderStepButtonsBaseComponentProps

const QuoteOrderFinishedStepHeaderDecider: React.FC<QuoteOrderFinishedStepHeaderProps> = ({...rest}) => {
    return (
        <AppStyleDecider DefaultComponent={QuoteOrderFinishedStepHeaderDefault} NewComponent={QuoteOrderFinishedStepHeaderNew} {...rest} />
    )
}

const QuoteOrderFinishedStepHeaderDefault: React.FC<QuoteOrderFinishedStepHeaderProps> = ({...rest}) => {
    return (
        <div className='flex gap-10 justify-between flex-wrap items-center flex-auto'>
            <QuoteOrderStatusBar {...rest} />
            <QuoteOrderFinishedStepButtons {...rest} />
        </div>
    )
}

const QuoteOrderFinishedStepHeaderNew: React.FC<QuoteOrderFinishedStepHeaderProps> = ({...rest}) => {
    return (
        <Fragment>
            <QuoteOrderStatusBarNew {...rest} />
            <QuoteOrderFinishedStepButtonsNew {...rest} />
        </Fragment>
    )
}

export default QuoteOrderFinishedStepHeaderDecider